import classNames from "classnames";
import React from "react";

export enum CardTypes {
  Primary = "primary",
  Secondary = "secondary",
}

export interface CardProps {
  children: React.ReactNode;
  type?: CardTypes;
}

const Card = ({ children, type = CardTypes.Secondary }: CardProps) => {
  const classColors = (type: CardTypes) => {
    switch (type) {
      case CardTypes.Primary:
        return "bg-secondary-main text-secondary-main border-secondary-main";
      case CardTypes.Secondary:
        return "bg-primary-main text-primary-main border-primary-main";
      default:
        return "bg-brand-light text-secondary-medium";
    }
  };

  return (
    <div
      className={classNames("border rounded p-3 shadow-lg", classColors(type))}
    >
      {children}
    </div>
  );
};

export default Card;
